import { DefaultRootState } from "@reduxLocal/persistState";
import React from "react";
import DropDownPicker from "react-native-dropdown-picker";
import { useSelector } from "react-redux";


const CalendarSelect = () => {
  const activeCals = useSelector((state: DefaultRootState) => state.calendar.availableCalendars);

  return (
    <DropDownPicker 
      items={activeCals.map(cal => ({ label: cal?.title || cal.calendar?.title, value: cal.id }))}
      containerStyle={{height: 40}}
      style={{backgroundColor: '#fafafa'}}
      itemStyle={{
          justifyContent: 'flex-start'
      }}
      dropDownStyle={{backgroundColor: '#fafafa'}}
      onChangeItem={item => console.log(item.label, item.value)}
    />
  )
}
export default CalendarSelect;